
import { defineComponent, PropType, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import {} from "@/types/pantry";
import SelectingIngredientList from "@/components/common/SelectingIngredientList.vue";
import { SelectingIngredientListDataItem } from "@/types/common";
import PantryIngredientEmptyView from "./PantryIngredientEmptyView.vue";
export default defineComponent({
  name: "PantryIngredientView",
  components: {
    SelectingIngredientList,
    PantryIngredientEmptyView
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    categoryTitle: {
      type: String,
      default: "",
      required: true
    },
    ingredientList: {
      type: Array as PropType<SelectingIngredientListDataItem[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    const onSelectIngredient = (
      id: number,
      name: string,
      isSelect: boolean
    ) => {
      NativeClient.sendDebugLog(
        "PantryIngredientView onSelectIngredient id=" +
          props.id +
          "ingredientId = " +
          id +
          "name = " +
          name +
          ", isSelect = " +
          isSelect
      );
      context.emit("on-select", props.id, id, name, isSelect);
    };
    const isEmpty = () => {
      return !(props.ingredientList && props.ingredientList.length != 0);
    };
    return {
      isEmpty,
      onSelectIngredient
    };
  }
});
